export const whenToInvestInUxWebinar = {
  '@context': 'https://schema.org',
  '@type': 'Event',
  name: 'When to Invest in UX Strategy for Your Company',
  location: 'online',
  description:
    'Watch a webinar on the role of UX in business growth and innovation featuring industry leaders: Ahmed Rawass, Senior Manager UX at Takamol Holding, and Anna Zarudzka, co-CEO of Boldare. Designed specifically for C-level leaders, this session will focus on the strategic value of User Experience (UX) in digital product portfolios.',
  organizer: {
    '@type': 'Organization',
    name: 'Boldare',
    url: 'https://www.boldare.com',
  },
  performer: [
    {
      '@type': 'Person',
      name: 'Anna Zarudzka',
      jobTitle: 'co-CEO | Boldare',
    },
    {
      '@type': 'Person',
      name: 'Ahmed Rawass',
      jobTitle: 'Senior Manager UX | Takamol',
    },
  ],
  url: 'https://www.boldare.com/when-to-invest-in-ux-webinar/',
};
